const retryFetch = require("../../utils/retry-fetch");
 

const getRequestObject = (userId, securemaBaseUrl, market) => ({
  method: "GET",
  headers: {
    Accept: "application/vnd.middleware-v1+json",
    Contract: CONFIG.iowsApiContract,
    Consumer: CONFIG.iowsApiConsumer,
  },
  url: `${securemaBaseUrl}/${market}/customer/irw/${userId}/shoppingbags/onlineshoppinglist`,
  mode: "cors",
  cache: "default",
  credentials: "include",
});

const getBagsForUser = (userId) => {
  const requestObject = getRequestObject(
    userId,
    CONFIG.securemaBaseUrl,
    CONFIG.iowsLocale,
   );
  return retryFetch(3, 1000)(requestObject.url, requestObject).then(
    (response) => {
      const shoppingBagRef = response;
      if (!shoppingBagRef) return [];
      return Array.isArray(shoppingBagRef) ? shoppingBagRef : [shoppingBagRef];
    }
  );
};

const fetchLists = (sessionContext) =>
  getBagsForUser(sessionContext.userId)
    .then((bags) => ({
      status: "LIST_FETCH_SUCCESS",
      bags: bags.map((bag) =>  {
        return{
          id: bag.bagId,
          name: bag.bagName,
          noOfItems: bag.noOfItems,
        }
       
      }),
    }))
    .catch(() => ({ status: "LIST_FETCH_FAIL" }));

module.exports = fetchLists;
